import { render, staticRenderFns } from "./ReturnStatusesList.vue?vue&type=template&id=efd0547c&"
import script from "./ReturnStatusesList.vue?vue&type=script&lang=js&"
export * from "./ReturnStatusesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports